module.exports = __webpack_public_path__ + "media/promo/advent/images/bgm-4fe2d992a6ec683a7dc0dac8273c30b1.jpg";